import {Component, Property} from '@wonderlandengine/api';
import {vec3, quat, glMatrix, mat3, mat4} from 'gl-matrix';

/**
 * head-Rotation-test
 */
export class HeadTest extends Component {
    static TypeName = 'head-test';
    /* Properties that are configurable in the editor */
    static Properties = {
        nonVRHead: Property.object(),
        testObj: Property.object(),
    };

    start() {
        window.addEventListener("keydown", this.pressStart.bind(this));
    }

    update(dt) {
        /* Called every frame. */
    }

    pressStart(e) {
        //this.nonVRHead
        //this.object.rotateAxisAngleDegObject[[1, 0, 0], 0];

        // this.nonVRHeadRot = this.getRotationEuler(this.nonVRHead);
        // this.testObjRot = this.getRotationEuler(this.testObj);
        // this.setRotationEuler(this.testObj, [this.testObjRot[0], this.nonVRHeadRot[1], this.testObjRot[2]]);

        //const axis = vec3.fromValues(0, 1, 0); // Y-axis
        //this.setRotationAxis(this.testObj, axis, this.nonVRHead);

        //this.matchRotationY(this.testObj, this.nonVRHead);
        
        this.test5();
        
    }

    /* test 1 */
    setRotationEuler(obj, eulerRotation) {
        const quatRotation = quat.create();
        quat.fromEuler(
            quatRotation,
            eulerRotation[0],
            eulerRotation[1],
            eulerRotation[2],
        );
        obj.setRotationWorld(quatRotation);
    }

    getRotationEuler(obj) {
        const quaternionRotation = obj.getRotationWorld();
        const matThree = mat3.create();
        mat3.fromQuat(matThree, quaternionRotation);
    
        const radian = [0, 0, 0];
    
        // Rotation order is ZYX
        radian[1] = Math.asin(-Math.min(Math.max(matThree[2], -1), 1));
    
        if (Math.abs(matThree[2]) < 1 - 0.0000001) {
            radian[0] = Math.atan2(matThree[5], matThree[8]);
            radian[2] = Math.atan2(matThree[1], matThree[0]);
        } else {
            radian[0] = 0;
            radian[2] = Math.atan2(-matThree[3], matThree[4]);
        }
    
        const degreesArray = radian.map((radian) => radian * (180 / Math.PI));
        return degreesArray;
    }

    /* test 2 */
    setRotationAxis(obj, axis, targetObj) {
        const targetRotation = targetObj.getRotationWorld();
        const targetAxis = vec3.transformQuat(vec3.create(), axis, targetRotation);
        const angle = Math.acos(vec3.dot(targetAxis, axis));
        const rotation = quat.setAxisAngle(quat.create(), axis, angle);
        obj.setRotationWorld(rotation);
    }

    getRotationAxisAngle(obj) {
        const quatRotation = obj.getRotationWorld();
        const axisAngle = quat.getAxisAngle(vec3.create(), quatRotation);
        const axis = axisAngle.slice(0, 3); // Extract axis vector
        const angleInRadians = axisAngle[3]; // Extract angle in radians
        return { axis, angleInRadians };
    }

    /* Test 3 */
    matchRotationY(obj1, obj2) {
        const obj1Rotation = obj1.getRotationWorld();
        const obj2Rotation = obj2.getRotationWorld();
      
        const obj2RotationAxisAngle = quat.getAxisAngle(vec3.create(), obj2Rotation);
      
        const obj1NewRotation = quat.setAxisAngle(quat.create(), [0, 1, 0], obj2RotationAxisAngle[1]);
        
        obj1.setRotationWorld(obj1NewRotation);
    }

    /* Test 4 */
    test4() {
        const headRotation = quat.create();
        this.nonVRHead.getRotationWorld(headRotation);

        const yRotation = quat.create();
        quat.setAxisAngle(yRotation, [1, 0, 0], quat.getAxisAngle([1, 0, 0], headRotation));

        this.testObj.setRotationWorld(yRotation);

    }

    /* Test 5 */
    test5() {
        // const headRotation = quat.create();
        // this.nonVRHead.getRotationWorld(headRotation);
        
        // this.headEulerAngles = vec3.create();
        // vec3.set(this.headEulerAngles, 0, 0, 0);
        // //quat.getEuler(headEulerAngles, headRotation);
        // this.headEulerAngles = this.getEulerAnglesFromQuaternion(headRotation);

        // const newYRotation = quat.create();
        // quat.fromEuler(newYRotation, 0, this.headEulerAngles[1], 0);

        // this.testObj.setRotationWorld(newYRotation);


        const headRotation = quat.create();
        this.nonVRHead.getRotationWorld(headRotation);

        const euler = this.getEulerAnglesFromQuaternion(headRotation);
        const newYRotation = quat.fromEuler(quat.create(), euler[0], 0, 0);

        this.testObj.setRotationWorld(newYRotation);
    }

    getEulerAnglesFromQuaternion(quat) {
        const sqw = quat[3] * quat[3];
        const sqx = quat[0] * quat[0];
        const sqy = quat[1] * quat[1];
        const sqz = quat[2] * quat[2];
        const unit = sqx + sqy + sqz + sqw; // Should be 1 due to quaternion normalization
      
        const test = quat[0] * quat[1] + quat[2] * quat[3];
        const heading = Math.atan2(2 * test, 1 - 2 * (sqy + sqz));
        const attitude = Math.asin(2 * test / unit);
        const bank = Math.atan2(2 * (quat[0] * quat[3] - quat[1] * quat[2]), 1 - 2 * (sqx + sqz));
      
        return [bank, heading, attitude];
    }

}
